/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import html2pdf from 'html2pdf.js';
import * as XLSX from "xlsx";
import groupbarchart from '../../custom_lib/AiCharts/groupbarchart.vue';
import stackedbarchart from '../../custom_lib/AiCharts/StackedBarchart.vue';
import barchart from '../../custom_lib/AiCharts/adbarchart.vue';
import histogram from '../../custom_lib/AiCharts/histogram.vue';
import piechart from '../../custom_lib/AiCharts/D3PieChart.vue';
import advtable from '../../custom_lib/AiCharts/advenenttable.vue';
import aepiechart from '../../custom_lib/AiCharts/aepiechart.vue';
import historytab from '../../custom_lib/AiCharts/historytab.vue';
import survivalhorizondal from "../../custom_lib/AiCharts/horizondalpercentage.vue";
import chartdrill from '../../custom_lib/AiCharts/popupfiles/chartdrillPopup.vue';
import store from "@/store";

export default {
  name: "labresultsreport",
  components: {
    groupbarchart,
    barchart,
    histogram,
    piechart,
    advtable,
    aepiechart,
    historytab,
    stackedbarchart,
    survivalhorizondal,
    chartdrill
  },
  props: {
    templateId: {
      type: String,
      default: ''
    },
    resultCount: {
      type: Object,
      default: () => ({
        noOfSubjects: 0,
        noOfSubjectsEnrolledByAI: 0,
        noOfSubjectsRejectedByAI: 0
      }),
    },
    fromPage: {
      type: String,
      default: ""
    },
  },
  async mounted() {
    this.studyId = store.getters.getStudyIs;
    await this.getVersion();
    await this.getdata();
    this.targetValue = this.resultCount.noOfSubjects;
    this.startRolling();

    window.addEventListener("studyIdChanged", async () => {
      this.studyId = store.getters.getStudyIs;
      await this.getVersion();
      await this.getdata();
    });
  },
  data() {
    return {
      arrayofkeys: [
        "STUDYID",
        "DOMAIN",
        "SITEID",
        "USUBJID",
        "SUBJID",
        "LBSEQ",
        "LBTESTCD",
        "LBTEST",
        "LBCAT",
        "LBORRES",
        "LBORRESU",
        "LBORNRLO",
        "LBORNRHI",
        "LBSTRESC",
        "LBSTRESN",
        "LBSTRESU",
        "LBSTNRLO",
        "LBSTNRHI",
        "LBNRIND",
        "LBBLFL",
        "VISITNUM",
        "VISIT",
        "VISITDY",
        "LBDTC",
        "LBDY",
        "LBSPEC",
        "LBSPCCND",
        "LBMETHOD"
      ],
      groupchartkeys: {
        "xaxiskey": "LBSPEC",
        "groupkey": "LBTEST",
      },
      yValues: ["ABNORMAL HIGH", "ABNORMAL LOW", "NORMAL"],
      maximizedcomp: "",
      drilldata: {},
      loader: true,
      expandBlock: false,
      data: [],
      datahistory: [],
      columns: [],
      historykeys: [],
      historydata: {},
      drilldowndata: [],
      currentValue: 0,
      targetValue: 0,
      duration: 2000,
      displayValue: 0,
      basetestUrl: process.env.VUE_APP_Service_URL,
      baseUrl: process.env.VUE_APP_Service_URL + "/forms-ml/patientenroll/",
      selectedChartType: 'Comparitive Bar chart',
      chartTypes: ['Comparitive Bar chart', 'Pie Chart', 'Bar Chart', 'Line Chart',],
      drillpopup: false,
      studyId: "",
      interimVersion: "",
      versionList: null,
      xaxiskeys: {
        "horizondalpercent": "",
        "groupbarchart": "",
        "barchart": "",
        "histogram": "",
        "piechart": "AESEV",
        "advtable": "",
        "aepiechart": "",
        "historytab": "",
        "chartdrill": ""
      }
    };
  },
  methods: {
    async getVersion() {
      const idtoken = store.getters.getIdToken;
      await axios.get(
        `${this.basetestUrl}/forms/cdisc/listauditsdtm?StudyId=${this.studyId}`,
        {
          headers: {
            Authorization: `Bearer ${idtoken}`,
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        this.versionList = res.data.entities.filter(entity => entity.interimVersion !== null && entity.interimVersion !== "");
        if (this.versionList.length > 0) {
          this.interimVersion = this.versionList[0].interimVersion;
        }
      }).catch((err) => {
        console.log("err", err);
      });
    },
    async setVersionNo() {
      await this.getdata();
    },
    async exporttoexcell() {
      const worksheet = XLSX.utils.json_to_sheet(this.data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "Lab Summary Report.xlsx");
    },
    exporttopdf() {
      const pdfContainer = document.createElement('div');
      const pdfContainer1 = document.createElement('div');
      const pdfContainer2 = document.createElement('div');
      const pdfContainer3 = document.createElement('div');
      const pdfContainer4 = document.createElement('div');
      const pdfContainer5 = document.createElement('div');

      const captureArea1 = this.$refs.captureArea1.cloneNode(true);
      const captureArea2 = this.$refs.captureArea2.cloneNode(true);
      const captureArea3 = this.$refs.captureArea3.cloneNode(true);
      const captureArea4 = this.$refs.captureArea4.cloneNode(true);
      const captureArea5 = this.$refs.captureArea5.cloneNode(true);

      captureArea2.classList.add('page-break');
      captureArea3.classList.add('page-break');
      captureArea4.classList.add('page-break');
      captureArea5.classList.add('page-break');

      pdfContainer1.appendChild(captureArea1);
      pdfContainer2.appendChild(captureArea2);
      pdfContainer3.appendChild(captureArea3);
      pdfContainer4.appendChild(captureArea4);
      pdfContainer5.appendChild(captureArea5);

      pdfContainer1.style.width = '100%';
      pdfContainer2.style.width = '150%';
      pdfContainer3.style.width = '150%';
      pdfContainer4.style.width = '150%';
      pdfContainer5.style.width = '150%';

      pdfContainer.appendChild(pdfContainer1);
      pdfContainer.appendChild(pdfContainer2);
      pdfContainer.appendChild(pdfContainer3);
      pdfContainer.appendChild(pdfContainer4);
      pdfContainer.appendChild(pdfContainer5);

      pdfContainer.style.display = 'block';
      const opt = {
        margin: 0,
        filename: 'Lab Summary Report.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' }
      };

      html2pdf().set(opt).from(pdfContainer).save();
    },
    async retaingroupchartvars(groupvars) {
      if (groupvars.xaxiskey != "" && groupvars.groupkey != "") {
        this.groupchartkeys = groupvars;
      }
    },
    async retainvisitkey(xaxiskey) {
      if (xaxiskey != "") {
        this.xaxiskeys["horizondalpercent"] = xaxiskey;
      }
    },
    startRolling() {
      const start = this.currentValue;
      const end = this.targetValue;
      const duration = this.duration;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        if (elapsedTime < duration) {
          const progress = elapsedTime / duration;
          this.displayValue = Math.floor(start + progress * (end - start));
          requestAnimationFrame(animate);
        } else {
          this.displayValue = end;
        }
      };

      requestAnimationFrame(animate);
    },
    async undobutton() {
      if (this.datahistory.length > 1) {
        this.datahistory.pop();
        this.data = this.datahistory[this.datahistory.length - 1];
      }
    },
    changetomaxcomponent(compval) {
      this.maximizedcomp = compval;
    },
    changetominomponent() {
      this.maximizedcomp = "";
    },
    async onclosed() {
      this.drillpopup = false;
    },
    async drillpopupopened(datafromchild) {
      this.drilldata = datafromchild;
      this.drillpopup = true;
    },
    async drilldowncurrentchart(datafromchild) {
      this.data = datafromchild;
      this.datahistory.push(this.data);
    },
    async drilldowncurrentchartforbar(datafromchild) {
      const lastkey = this.historykeys[this.historykeys.length - 1];
      if (this.historydata[lastkey].length != datafromchild.sortedData.length) {
        this.historykeys.push(datafromchild.filterkeyword);
        this.historydata[datafromchild.filterkeyword] = datafromchild.sortedData;
        this.data = this.historydata[datafromchild.filterkeyword];
      }
    },
    async gotohistorylevel(history) {
      this.deleteAfterKeyvaluearrays(history);
      this.deleteAfterKeyarrays(history);
      this.data = this.historydata[history];
    },
    async deleteAfterKeyvaluearrays(selectedKey) {
      const entries = Object.entries(this.historydata);
      const selectedIndex = entries.findIndex(([key, value]) => key === selectedKey);
      const newEntries = selectedIndex !== -1 ? entries.slice(0, selectedIndex + 1) : entries;
      return Object.fromEntries(newEntries);
    },
    async deleteAfterKeyarrays(selectedKey) {
      let index = this.historykeys.indexOf(selectedKey);
      if (index !== -1) {
        this.historykeys = this.historykeys.slice(0, index + 1);
      }
    },
    async headderforbarcomparitive(repfieldname) {
      this.comparitivebarheader = repfieldname;
    },
    async getdata() {
      this.loader = true;
      const filters = [
        {
          operation: "=",
          field: "StudyId",
          value: this.studyId
        },
        {
          operation: "=",
          field: "InterimVersion",
          value: this.interimVersion
        }
      ];
      await axios.post(
        `${this.basetestUrl}/forms-ml/report/getallreports?table_name=LB`, { filters })
        .then((res) => {
          this.data = res.data;
          this.loader = false;
          this.columns = [...new Set(this.data.map(item => item.VISITNUM))];
          this.datahistory.push(this.data);
          this.historydata['Home'] = this.data;
          if (!this.historykeys.includes('Home')) {
            this.historykeys.push('Home');
          }
        })
        .catch((err) => console.log("error in screen list", err));
    },
    async pageclosed() {
      this.$router.push(`/analyticalDashboard`);
    }
  },
};